import adapter from 'webrtc-adapter';
import 'core-js/proposals/set-methods-v2';

// adapter가 번들링할 때 import될 수 있도록 추가
adapter.disableLog(true);
